import { getServiceUrl } from '../api.config';
import { ApiClientOptions } from '../types/api';
import { LegalIdentifier } from '../types/legalidentifier';
import ApiClient from '../utils/ApiClient';
import { isNotEmptyString } from '../utils/validators';

export default class LegalIdentifierApi extends ApiClient {
  public constructor(options?: ApiClientOptions) {
    super(getServiceUrl('auth'), options);
  }

  // --------------------------------------------------------------------------
  // MailDomain
  // --------------------------------------------------------------------------

  public LegalIdentifierList() {
    const query = '/auth/v3/organization/legalidentifier';
    return this.get<LegalIdentifier[]>(query);
  }

  public LegalIdentifierCreate(type: string, value: string) {
    const query = '/auth/v3/organization/legalidentifier';
    const data: any = {};

    if (isNotEmptyString(type)) {
      data.type = type;
    }
    if (isNotEmptyString(value)) {
      data.value = value;
    }

    return this.post(query, data);
  }

  public LegalIdentifierCreateMultiple(
    legalIdentifiers: { type: string; value: string }[],
  ) {
    const query = '/auth/v3/organization/legalidentifier';
    const data: any = {};

    data.legal_identifiers = legalIdentifiers;

    return this.post(query, data);
  }

  public LegalIdentifierDelete(id?: number) {
    const query = `/auth/v3/organization/legalidentifier/${id}`;
    return this.delete(query, {});
  }
}
